export default "__VITE_ASSET__CZbeZBMz__"